<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import has from 'lodash/has';
import moment from 'moment';

import WEventCommonTable from '@/views/event/components/EventCommonTable';
import MapAPI from '@/api/topologymap/common';
import FileApi from '@/api/common/file';

export default {
  name: 'WTopologymapEventCommonTable',
  extends: WEventCommonTable,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
    };
  },
  watch: {
    active: {
      handler(value) {
        if (value === false) {
          this.clear();
        }
      },
    },
  },
  methods: {
    loadData() {
      if (isEmpty(this.eventTableColumns)) {
        this.setEventTableColumns();
      }
      if (isNil(this.active) || !this.active) {
        return;
      }
      const headerSearchParams = this.getHeaderSearchParams();
      const params = {
        customerId: this.customerId,
        filterParams: this.filterParams,
        startDatetime: moment().subtract(1, 'days').valueOf(),
        endDatetime: moment().valueOf(),
        headerSearchParams,
        ...headerSearchParams,
        mapId: this.$store.getters.getCurrentMapId,
      };
      delete params.eventlevelId;

      if (isEqual(this.eventType, 'status')) {
        this.isLoading = true;
        MapAPI.getEventStatusList(params).then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.eventTableData = result.data;
            this.total = result.total;
          } else {
            this.eventTableData = [];
            this.total = 0;
          }
          this.$nextTick(() => {
            this.isLoading = false;
          });
        }).catch(() => {
          this.eventTableData = [];
          this.total = 0;
        });
      } else {
        this.isLoading = true;
        MapAPI.getEventHistList(params).then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.eventTableData = response.data.data;
            this.total = response.data.total;
          } else {
            this.eventTableData = [];
            this.total = 0;
          }
          this.$nextTick(() => {
            this.isLoading = false;
          });
        }).catch(() => {
          this.eventTableData = [];
          this.total = 0;
          this.isLoading = false;
        });
      }
      if (this.selectedRowArray.length > 0) {
        const eventTable = this.$refs.eventTable;
        eventTable.$children[0].clearSelection();
        this.selectedRowArray = []; // 선택한 row들 내역 초기화
      }
    },
    exportExcel() {
      const headerSearchParams = this.getHeaderSearchParams();
      if (has(headerSearchParams, 'start')) {
        delete headerSearchParams.start;
      }
      if (has(headerSearchParams, 'limit')) {
        delete headerSearchParams.limit;
      }
      const params = {
        customerId: this.customerId,
        startDatetime: moment().subtract(1, 'days').valueOf(),
        endDatetime: moment().valueOf(),
        mapId: this.$store.getters.getCurrentMapId,
        filterParams: this.filterParams,
        headerSearchParams,
        ...headerSearchParams,
      };

      const excelFunction = this.eventType === 'status' ? MapAPI.getEventStatusExcelName : MapAPI.getEventHistExcelName;
      excelFunction(params).then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          FileApi.downloadExportedExcelFile(response.data.data);
        }
      });
    },
    clear() {
      this.isLoading = false;
      this.eventTableData = null;
      this.selectedRowArray = [];
      this.total = 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/event/TopologymapEventCommonTable.vue